import { useRef, useState } from 'react';
import { useBackend } from '../../../Hooks/UseBackend';
import { ImageSource } from './types';
import { base64ToFile } from '../../../utils/base64-to-file';
import { toast } from 'react-toastify';

export function AIImageGenerator({ onImageChange }: ImageSource) {
    const { generateImage } = useBackend();

    const ref = useRef<HTMLTextAreaElement>(null);

    const [loading, setIsLoading] = useState(false);

    return (
        <>
            <textarea ref={ref} placeholder='Enter prompt here' className='ai-image-prompt' disabled={loading} />
            <button
                className='ai-generate-image-btn'
                onClick={() => {
                    if (ref.current?.value) {
                        setIsLoading(true);

                        generateImage({
                            prompt: ref.current.value,
                            size: '1024x1024',
                            quality: 'standard',
                            style: 'natural',
                        })
                            .then((data) => {
                                const base64 = `data:image/jpeg;base64,${data}`;
                                const file = base64ToFile(base64, `${ref.current?.value.replace(/\s+/g, '')}.jpg`);

                                onImageChange(base64, file);

                                setIsLoading(false);
                            })
                            .catch((message) => {
                                toast.error(message);
                                setIsLoading(false);
                            });
                    }
                }}
            >
                {loading ? <div className='spinner' /> : 'Generate'}
            </button>
        </>
    );
}
